import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { TokenService } from '../../services/token/token.service';
import { FormatService } from '../../services/format/format.service';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage/storage.service';

@Component({
  selector: 'app-instagram-callback',
  standalone: true,
  imports: [HttpClientModule],
  providers: [HttpClient, TokenService],
  templateUrl: './instagram-callback.component.html',
  styleUrl: './instagram-callback.component.scss'
})
export class InstagramCallbackComponent implements OnInit {

  instagramAccount: {
    account_type: string;
    creatorId: string;
    followers_count: number;
    instagram_account_id: string;
    name: string;
    profile_picture_url: string;
    user_id: string;
    username: string;
    follows_count: number;
    media_count: number;
  } | undefined;

  connectionError: boolean = false;
  
  constructor(
    private router: Router,
    private tokenService: TokenService,
    public formatService: FormatService,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    console.log('InstagramCallbackComponent ngOnInit()');
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    console.log('InstagramCallbackComponent code: ', code);

    if (code) {
      this.exchangeCodeForToken(code);
    }
  }

  async exchangeCodeForToken(code: string) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    let body = {
      client_id: environment.instagram.clientId,
      client_secret: environment.instagram.ig_app_secret,
      grant_type: 'authorization_code',
      redirect_uri: environment.instagram.redirectUri,
      code: code
    }

    try {
      const tokenResponse = await firstValueFrom(this.tokenService.exchangeCodeForTokenInstagram(code));
      console.log('Token exchange successful:', tokenResponse);

      this.instagramAccount = tokenResponse;
      
    } catch (error) {
      console.error('Token exchange failed:', error);
    }
  }

  async saveAuthFactors(tokenResponse: any) {
    console.log('saveAuthFactors() ---->');
    console.log(tokenResponse);
  }

  connectAnotherAccount() {
    console.log('Connect another account');

    const businessId = this.storageService.get('businessId');
    const externalId = this.storageService.get('externalId');

    console.log('External ID:', externalId);
    console.log('Business ID:', businessId);
    this.router.navigate([`/connect/${externalId}/${businessId}`]);
  }

  exitBrowser() {
    console.log('Exit browser');
    window.close();
  }
}
